import React from 'react';
import '../styles/neon.css';
import './HeroLogo.css';

const HeroLogo = ({ visible }) => {
    if (!visible) return null;

    return (
        <div style={{ pointerEvents: 'none', width: '100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div className="hero-logo-container">
                <h1 className="hero-title neon-text-pink flicker-slow" aria-hidden="true">
                    <span className="sabha">स</span>AMAARAM<span className="sabha">भ</span> 10.O
                </h1>
                {/* Visually hidden text for SEO and Accessibility */}
                <div style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: '0' }}>
                    <h1>Samaraambh 10.0 - IIM Vizag Cultural Fest</h1>
                    <p>Welcome to Samaarambh (Samaraambh), the biggest annual cultural events in Vizag and Visakhapatnam, hosted by IIM Visakhapatnam (IIM Vizag). Join us for music, dance, and carnival events.</p>
                </div>
                <div className="marquee-container">
                    <span className="marquee-content" style={{ animation: 'marquee 10s linear infinite', display: 'inline-block' }}>
                        MILLENNIUM DREAMLAND • Y2K CARNIVAL • IIM VISAKHAPATNAM • SAMAARAMBH • IIM VIZAG CULTURAL FESTIVAL •
                    </span>
                </div>

                {/* Dates Added Here */}
                <h2 className="hero-dates neon-text-cyan flicker-fast" style={{
                    marginTop: '25px',
                    fontSize: '0.9rem',
                    letterSpacing: '4px',
                    textTransform: 'uppercase',
                    textShadow: '0 0 10px #00F5FF, 0 0 20px #00F5FF'
                }}>
                    27th & 28th Feb 2026
                </h2>
            </div>
        </div>
    );
};

export default HeroLogo;
